import { render, staticRenderFns } from "./QuickInfo.vue?vue&type=template&id=c6c1246c&scoped=true&"
import script from "./QuickInfo.vue?vue&type=script&lang=js&"
export * from "./QuickInfo.vue?vue&type=script&lang=js&"
import style0 from "./QuickInfo.vue?vue&type=style&index=0&id=c6c1246c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c1246c",
  null
  
)

export default component.exports